:host{overflow-y:auto;overscroll-behavior:none;display:grid;grid-template-rows:auto;gap:1px;background-color:#f6f6f6}
/*# sourceMappingURL=scrollable-list.component.css.map */
